import { Injectable } from '@angular/core';
import { MatDrawerMode } from '@angular/material/sidenav';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, filter } from 'rxjs/operators';

import {
  LayoutClassesEnum,
  LayoutClassesEnumNames,
} from '../models/layout-classes.enum';
import { LocalStorageService } from './local-storage.service';

const isOpenedStoreKey = 'is_opened_left_menu';

@Injectable({
  providedIn: 'root',
})
export class NavbarService {
  public readonly version = 'Brokers - 0.0.1';
  public activeLink = new BehaviorSubject('');
  public isOpenedMenu = this.localStorageService.getBoolean(isOpenedStoreKey);
  public modeMenu: MatDrawerMode = 'side';
  public readonly items = [
    {
      title: 'Dashboard',
      path: '/dashboard',
      icon: 'dashboard',
    },
    {
      title: 'Widgets',
      path: '/widgets',
      icon: 'widgets',
    },
    {
      title: 'Widget Rotators',
      path: '/widget-rotators',
      icon: 'rotate_90_degrees_cw',
    },
  ];
  public isDesktop: boolean = true;
  // By default we apply Desktop layout. Changes comes from app.component
  public layoutClass: string =
    LayoutClassesEnumNames[LayoutClassesEnum.Desktop];

  constructor(
    private router: Router,
    private localStorageService: LocalStorageService,
  ) {
    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe(() => {
        this.activeLink.next(this.router.url.split(/[?#]/)[0]);
        if (this.isDesktop) {
          this.openMenu();
        }
      });
  }

  public setLayout(layout: LayoutClassesEnum) {
    this.isDesktop = layout === LayoutClassesEnum.Desktop;
    this.modeMenu =
      layout === LayoutClassesEnum.Desktop
        ? 'side'
        : layout === LayoutClassesEnum.Tablet
        ? 'push'
        : 'over';
    this.layoutClass = LayoutClassesEnumNames[layout];
    if (!this.isDesktop) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }

  public openMenu(): void {
    this.isOpenedMenu = true;
  }

  public closeMenu(): void {
    this.isOpenedMenu = false;
  }

  public closeMenuIfMobile(): void {
    if (!this.isDesktop) {
      this.closeMenu();
    }
  }

  public toggleMenu(): void {
    this.isOpenedMenu = !this.isOpenedMenu;
  }

  public async goBack() {
    if (window.history.length > 0) {
      window.history.back();
    } else {
      await this.router.navigate(['../']);
    }
  }
}
